import React from 'react';
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import { createStore, applyMiddleware, combineReducers } from 'redux'
import { resettableReducer } from 'reduxsauce'
// import { createLogger } from 'redux-logger'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import { App } from './modules/app'
import './assets/styles/css/index.css'

/** REDUCERS **/
import { reducer as formReducer } from 'redux-form'
import { 
    satReducers, 
    nfceReducers, 
    empresasReducers, 
    nfeReducers, 
    cteReducers, 
    movimentacaoReducers,
    receitasFinanceirasReducers 
} from './modules/fiscal'
import { pendenciasReducers } from './modules/docsystem'

// const logger = createLogger({
//     duration: true,
//     diff: true
// })
const resettable = resettableReducer('RESET')

const Store = createStore(
    combineReducers({
        form: resettable(formReducer),
        satState: resettable(satReducers),
        nfceState: resettable(nfceReducers),
        empresasState: resettable(empresasReducers),
        nfeState: resettable(nfeReducers),
        cteState: resettable(cteReducers),
        pendenciasDocsystemState: resettable(pendenciasReducers),
        movReportState: resettable(movimentacaoReducers),
        receitasFinState: resettable(receitasFinanceirasReducers)
    }), 
    process.env.NODE_ENV === 'development' ? applyMiddleware(thunk) : applyMiddleware(thunk)
)

ReactDOM.render(
    <Provider store={Store}>
        <Router basename="/">
            <App />
        </Router>
    </Provider>, document.getElementById('root')
)
